module.exports = __webpack_public_path__ + "static/img/coner4.1b6427a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/coner4.png
// module id = 6kce
// module chunks = 1